/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState,
} from '@sg/api/base-api-lib';
import { UsersApiConfig } from '../api-config';

import { UsersApi } from '../models';

@Injectable()
export class UsersApiClient extends BaseApiClient<UsersApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.usersApiConfig);
  }

  getUsersUserInfo(
    params?: { app?: UsersApi.AppDto; activeOnly?: boolean },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<UsersApi.UserDto>;
  getUsersUserInfo(
    params?: { app?: UsersApi.AppDto; activeOnly?: boolean },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<UsersApi.UserDto>>;
  getUsersUserInfo(
    params?: { app?: UsersApi.AppDto; activeOnly?: boolean },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<UsersApi.UserDto>;
  getUsersUserInfo(
    params?: { app?: UsersApi.AppDto; activeOnly?: boolean },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<UsersApi.UserDto>>;
  getUsersUserInfo(
    params?: { app?: UsersApi.AppDto; activeOnly?: boolean },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<UsersApi.UserDto>>;
  getUsersUserInfo(
    params?: { app?: UsersApi.AppDto; activeOnly?: boolean },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<UsersApi.UserDto>>;
  getUsersUserInfo(
    params?: { app?: UsersApi.AppDto; activeOnly?: boolean },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    if (params) {
      requestContext.queryParams = this.createQueryParams(
        ['csv', 'app', params.app],
        ['csv', 'activeOnly', params.activeOnly],
      );
    }

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<UsersApi.UserDto>(
      `${this.basePath}/users/user/info`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  getUsersUserSettings(options?: {
    observe?: 'bodyPromise';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Promise<UsersApi.UserSettingsDto>;
  getUsersUserSettings(options?: {
    observe: 'responsePromise';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Promise<HttpResponse<UsersApi.UserSettingsDto>>;
  getUsersUserSettings(options?: {
    observe: 'body';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<UsersApi.UserSettingsDto>;
  getUsersUserSettings(options?: {
    observe: 'bodyWithState';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpRequestState<UsersApi.UserSettingsDto>>;
  getUsersUserSettings(options?: {
    observe: 'response';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpResponse<UsersApi.UserSettingsDto>>;
  getUsersUserSettings(options?: {
    observe: 'events';
    headers?: Array<[string, any]> | { [key: string]: any };
    reportProgress?: boolean;
    responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
  }): Observable<HttpEvent<UsersApi.UserSettingsDto>>;
  getUsersUserSettings(
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<UsersApi.UserSettingsDto>(
      `${this.basePath}/users/user/settings`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  postUsersUserSettings(
    body?: UsersApi.UpdateUserSettingsRequest,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<UsersApi.UserSettingsDto>;
  postUsersUserSettings(
    body?: UsersApi.UpdateUserSettingsRequest,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<UsersApi.UserSettingsDto>>;
  postUsersUserSettings(
    body?: UsersApi.UpdateUserSettingsRequest,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<UsersApi.UserSettingsDto>;
  postUsersUserSettings(
    body?: UsersApi.UpdateUserSettingsRequest,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<UsersApi.UserSettingsDto>>;
  postUsersUserSettings(
    body?: UsersApi.UpdateUserSettingsRequest,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<UsersApi.UserSettingsDto>>;
  postUsersUserSettings(
    body?: UsersApi.UpdateUserSettingsRequest,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<UsersApi.UserSettingsDto>>;
  postUsersUserSettings(
    body?: UsersApi.UpdateUserSettingsRequest,

    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<UsersApi.UserSettingsDto>(
      `${this.basePath}/users/user/settings`,
      body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  getUsersLegalEntityInfo(
    xSgUser?: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<UsersApi.LegalEntityDto>;
  getUsersLegalEntityInfo(
    xSgUser?: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<UsersApi.LegalEntityDto>>;
  getUsersLegalEntityInfo(
    xSgUser?: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<UsersApi.LegalEntityDto>;
  getUsersLegalEntityInfo(
    xSgUser?: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<UsersApi.LegalEntityDto>>;
  getUsersLegalEntityInfo(
    xSgUser?: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<UsersApi.LegalEntityDto>>;
  getUsersLegalEntityInfo(
    xSgUser?: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<UsersApi.LegalEntityDto>>;
  getUsersLegalEntityInfo(
    xSgUser?: string,

    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      this.serializeParam('csv', xSgUser),
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<UsersApi.LegalEntityDto>(
      `${this.basePath}/users/legal-entity/info`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  postUsersCallMe(
    xSgUser?: string,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<any>;
  postUsersCallMe(
    xSgUser?: string,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<any>>;
  postUsersCallMe(
    xSgUser?: string,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<any>;
  postUsersCallMe(
    xSgUser?: string,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<any>>;
  postUsersCallMe(
    xSgUser?: string,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<any>>;
  postUsersCallMe(
    xSgUser?: string,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<any>>;
  postUsersCallMe(
    xSgUser?: string,

    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      this.serializeParam('csv', xSgUser),
    ]);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<any>(
      `${this.basePath}/users/call-me`,
      null,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  putUsersChangePhoneNumber(
    body?: UsersApi.UpdateUserPhoneNumberRequest,

    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<any>;
  putUsersChangePhoneNumber(
    body?: UsersApi.UpdateUserPhoneNumberRequest,

    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<any>>;
  putUsersChangePhoneNumber(
    body?: UsersApi.UpdateUserPhoneNumberRequest,

    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<any>;
  putUsersChangePhoneNumber(
    body?: UsersApi.UpdateUserPhoneNumberRequest,

    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<any>>;
  putUsersChangePhoneNumber(
    body?: UsersApi.UpdateUserPhoneNumberRequest,

    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<any>>;
  putUsersChangePhoneNumber(
    body?: UsersApi.UpdateUserPhoneNumberRequest,

    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<any>>;
  putUsersChangePhoneNumber(
    body?: UsersApi.UpdateUserPhoneNumberRequest,

    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {});

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<any>(
      `${this.basePath}/users/change-phone-number`,
      body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
